import React, { useState } from "react"
import DatasetDropdown from '../../visualization-dropdown/DatasetDropdown'
import PopoverMenu from '../menuPopover/MenuPopover'
import SelectButton from "./SelectButton"
import styles from './SelectButton.module.scss'

export default function DatasetButton({index, columns, elevation=1, currentDataset, ...props }) {
    const [menuAnchorEl, setMenuAnchorEl] = useState(null)

    const handleClick = (event) => setMenuAnchorEl(event.currentTarget)

    const handleClose = () => setMenuAnchorEl(null)

    const dataName = `${currentDataset?.datasetName} / ${currentDataset?.columnName}`

    return (
        <>
            <SelectButton elevation={elevation} extraStyles={{button: [styles['sector-btn']]}} label='Dataset/Column' onClick={handleClick} value={currentDataset?.datasetValue ? dataName : 'Choose Dataset / Column'}/>
            <PopoverMenu
            anchorEl={menuAnchorEl}
            onClose={handleClose}>
                <DatasetDropdown close={handleClose} currentDataset={currentDataset} columns={columns} {...props}/>
            </PopoverMenu>
        </>
    )
}